/* eslint-disable import/order */
import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { func, number, shape } from 'prop-types';
import { useParams } from 'react-router-dom';

// styles
import {
  chevronRightStyles,
  chipStylesSelectedStyles,
  chipStylesStyles,
  flexRowStyles,
  inactiveCountSelectedStyles,
  inactiveCountStyles,
  labelStyles,
  linkStyles,
  ListItemHeaderContainerStyles,
  selectedListItemStyles,
  spaceBetweenStyles,
  titleStyles,
} from './Selector.styles';

// Components
import { ChevronRightRounded } from '@mui/icons-material';
import { ProductIndicatorBadge } from 'common';

// helpers
import { getSelectionURI } from 'utils/helpers/url';

const Selector = ({
  data,
  index,
  resetCardFilters,
  selectedIndex,
  setActiveMyAuthTab,
  setMobileDrawerOpen,
  setFilters,
  style,
}) => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
  const { viewBy } = useParams();

  const { selectorsData } = data;
  const { activeCount, inactiveCount, nameShort, proprietary } = selectorsData[index];

  const handleOnClick = idx => {
    resetCardFilters();
    setFilters({ name: 'selectedIndex', value: idx });
    setActiveMyAuthTab('baseProducts');
    if (!lgUp) {
      setMobileDrawerOpen(true);
    }
  };

  return (
    <ListItemHeaderContainerStyles
      key={nameShort}
      onClick={() => handleOnClick(index)}
      style={style}
      sx={{
        ...linkStyles(theme),
        ...(index === selectedIndex ? selectedListItemStyles(theme) : {}),
      }}
      to={`../my-authorizations/${viewBy}/${getSelectionURI(data.selectorsData[index])}`}
    >
      <Box sx={{ alignItems: 'flex-end', display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ ...titleStyles(theme) }}>{nameShort}</Box>
        <ChevronRightRounded sx={{ ...chevronRightStyles(theme) }} />
      </Box>
      <Box sx={{ ...flexRowStyles, ...spaceBetweenStyles }}>
        <Box sx={{ ...flexRowStyles }}>
          <span
            style={
              index === selectedIndex ? chipStylesSelectedStyles(theme) : chipStylesStyles(theme)
            }
          >
            {activeCount}
          </span>
          <Box sx={{ ...labelStyles(theme) }}>Active Authorizations</Box>
        </Box>
        {viewBy === 'product' && <ProductIndicatorBadge proprietary={proprietary} />}
      </Box>
      <Box sx={{ ...flexRowStyles }}>
        <span
          style={
            index === selectedIndex
              ? inactiveCountSelectedStyles(theme)
              : inactiveCountStyles(theme)
          }
        >
          {inactiveCount}
        </span>
        <Box sx={{ ...labelStyles(theme) }}>Inactive Authorizations</Box>
      </Box>
    </ListItemHeaderContainerStyles>
  );
};

Selector.propTypes = {
  data: shape({}).isRequired,
  index: number.isRequired,
  resetCardFilters: func.isRequired,
  selectedIndex: number,
  setActiveMyAuthTab: func.isRequired,
  setFilters: func.isRequired,
  setMobileDrawerOpen: func,
  style: shape({}),
};

Selector.defaultProps = {
  selectedIndex: undefined,
  setMobileDrawerOpen: () => {},
  style: {},
};

export default Selector;
